import { getCookieByName } from '../utils/helpers';
const url = new URLSearchParams(window.location.search);
const attendeeParam = url.get('host') === 'false';
export const getSpaceMockResponse = () => {
  const MEETING_ID = getCookieByName('google_meet_meeting_id') || 'E7Y0MEPh-1UC';
  const MEETING_UUID = getCookieByName('google_meet_meeting_uuid') || '6cfc7503-6d79-41da-a285-5eeda4f86f1d';
  return attendeeParam ? {
    name: `spaces/${MEETING_ID}`,
    meetingUri: 'https://meet.google.com/cpw-fqrj-ybm',
    meetingCode: 'cpw-fqrj-ybm',
    config: null,
    activeConference: null
  } : {
    name: `spaces/${MEETING_ID}`,
    meetingUri: 'https://meet.google.com/cpw-fqrj-ybm',
    meetingCode: 'cpw-fqrj-ybm',
    config: {
      accessType: 'TRUSTED',
      entryPointAccess: 'ALL'
    },
    activeConference: {
      conferenceRecord: `conferenceRecords/${MEETING_UUID}`
    }
  };
};
export const getGoogleParticipantsResponse = () => {
  const MEETING_UUID = getCookieByName('google_meet_meeting_uuid') || '6cfc7503-6d79-41da-a285-5eeda4f86f1d';
  return [{
    name: `conferenceRecords/${MEETING_UUID}/participants/be355518-cebd-4a81-8a47-e58a2f361f13`,
    earliestStartTime: {
      seconds: '1716824799',
      nanos: 4543000
    },
    latestEndTime: null,
    anonymousUser: {
      displayName: 'Test User1'
    },
    user: 'anonymousUser'
  }, {
    name: `conferenceRecords/${MEETING_UUID}/participants/103949702255284022501`,
    earliestStartTime: {
      seconds: '1716823574',
      nanos: 151503000
    },
    latestEndTime: null,
    signedinUser: {
      user: 'users/103949702255284022501',
      displayName: 'Test User2'
    },
    user: 'signedinUser'
  }];
};
export const getConferenceRecordMockResponse = () => {
  const conferenceRecordId = getCookieByName('google_meet_meeting_id') || 'E7Y0MEPh-1UC';
  const spaceId = getCookieByName('google_meet_meeting_uuid') || '6cfc7503-6d79-41da-a285-5eeda4f86f1d';
  return {
    id: '1',
    name: `conferenceRecords/${conferenceRecordId}`,
    startTime: 1743767908984,
    endTime: 1743767909984,
    expireTime: 1743767909984,
    space: `spaces/${spaceId}`
  };
};